$(document).ready(function() {
  $('#size_select_btn.add-to-cart').click(function() {   
    console.log("New",$(this));
    $(this).hide();
    $('.custom-Atc').show();
    $('.custom-variants-div').show();
  });
  
  $('.custom-variants-div.product-single__variants.no-js div').click(function(){
     $('.custom-variants-div.product-single__variants.no-js div').removeClass('Is-selected');
     $(this).addClass('Is-selected');
    
  });

  // $('.type-based-product-slider-main img').click(function(){
  //   $('.custom-Atc').hide();
  //   $('#size_select_btn.add-to-cart').show();
  //   $('.custom-variants-div').hide();
  // });
  // var pol = $('.New-Custom-Link');
  // $('body').click(function(e) {
  //   if(e.target != pol ){
  //          $('.custom-Atc').hide();
  //   $('#size_select_btn.add-to-cart').show();
  //   $('.custom-variants-div').hide();
  //    console.log("clicked", e.target);
  //   }
  // });
  // window.addEventListener('mouseup',function(event){
  //       var pol = document.getElementById('New-Custom-Link');
  //       if(event.target != pol && event.target.parentNode != pol){
  //           console.log("clicked", pol);
  //       }
  // });  
 $('.custom-Atc.add-to-cart').click(function() {

    var var_id = $('.Is-selected').attr("variant-id");
    console.log("-",var_id);

      $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: var_id
      },
        dataType: 'json', 
       success: function (data) { 

        console.log(data.quantity);
         var cart = new theme.CartDrawer;
          // cart.init()
          cart.open();
       
       } 
       });
      }); 
  
});


$(function () {
  const ITEMS_PER_LOAD = 4;

  $('.New-custom-grid').each(function () {
    const $grid = $(this);
    const $items = $grid.children('.grid__item');
    const $loadMoreBtn = $grid.closest('.type-based-product-slider-main').find('.loadMoreBtn');

    if (!$items.length) return;

    // 1️⃣ Hide items after first load
    $items.slice(ITEMS_PER_LOAD).addClass('hide');

    let visibleCount = ITEMS_PER_LOAD;

    // 2️⃣ Load more handler
    $loadMoreBtn.on('click', function () {
      $items
        .slice(visibleCount, visibleCount + ITEMS_PER_LOAD)
        .removeClass('hide');

      visibleCount += ITEMS_PER_LOAD;

      // 3️⃣ Remove button if all items are visible
      if (visibleCount >= $items.length) {
        $(this).fadeOut(200);
      }
    });

    // 4️⃣ Hide button if not required
    if ($items.length <= ITEMS_PER_LOAD) {
      $loadMoreBtn.hide();
    }
  });
});

